import { useEffect, useLayoutEffect, useRef, useState } from 'react';

import {
  Autoplay,
  EffectFade,
  FreeMode,
  Navigation,
  Pagination
} from 'swiper';
import { SwiperSlide } from 'swiper/react';
import {
  GradientBottom,
  SwiperStyled,
  SwiperWrapper,
} from './styles';

import 'swiper/modules/free-mode/free-mode.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/autoplay/autoplay.min.css';
import 'swiper/modules/effect-fade/effect-fade.min.css';
import 'swiper/swiper.min.css';
import useShowCarouselButtons from 'hooks/useShowCarouselButtons';


const CarouselBase = ({
  children,
  slidesPerView,
  renderNavigationBtns = () => { },
  renderPagination = () => { },
  loop,
  rewind,
  autoPlay,
  effect,
  offsetLeft = 35,
  offsetRight = 0,
  isGradientBottom,
  defaultSlidePosition = 0
}) => {

  const ref = useRef()

  const [index, setIndex] = useState(0);
  const [isFirstMount, setIsFirstMount] = useState(true);
  const [swiper, setSwiper] = useState();

  const { showNavigationBtns } = useShowCarouselButtons();

  const slides = Array.isArray(children) ? children : [children]
  const total = slides.length

  const handleNext = () => ref.current.swiper.slideNext()
  const handlePrev = () => ref.current.swiper.slidePrev()

  const handleIndexChange = ({ realIndex }) => setIndex(realIndex)

  const handleAutoplayStart = () => {
    if (!autoPlay) return
    ref.current.swiper.autoplay.start()
    ref.current.swiper.autoplay.run()
  }

  const handleAutoplayPause = () => {
    if (!autoPlay) return
    ref.current.swiper.autoplay.stop()
  }


  useEffect(() => {
    setIsFirstMount(false)
  }, [])


  useLayoutEffect(() => {

    if (!swiper) return

    const transition = isFirstMount ? 0 : 300

    if (loop) swiper.slideToLoop(defaultSlidePosition, transition, false)
    else swiper.slideTo(defaultSlidePosition, transition, false)

  }, [loop, defaultSlidePosition, isFirstMount, swiper])


  useLayoutEffect(() => {
    ref.current.swiper.allowTouchMove = !showNavigationBtns
  }, [showNavigationBtns])


  return (
    <>
      <SwiperWrapper
        onMouseEnter={handleAutoplayPause}
        onMouseLeave={handleAutoplayStart}
        onTouchStart={handleAutoplayPause}
        onTouchEnd={handleAutoplayStart}
      >
        <SwiperStyled
          ref={ref}
          speed={600}
          slidesPerView={slidesPerView}
          slidesPerGroup={slidesPerView}
          freeMode={!showNavigationBtns}
          rewind={rewind}
          loop={loop}
          effect={effect}
          spaceBetween={10}
          autoplay={autoPlay}
          loopPreventsSlide={false}
          modules={[
            FreeMode,
            Navigation,
            Pagination,
            Autoplay,
            EffectFade
          ]}
          onRealIndexChange={handleIndexChange}
          onSwiper={setSwiper}
          $offsetLeft={offsetLeft}
          $offsetRight={offsetRight}
          $isFade={effect === 'fade'}
        >
          {slides.map((slide, idx) => (
            <SwiperSlide key={idx} style={{ height: 'auto' }}>
              {slide}
            </SwiperSlide>
          ))}
        </SwiperStyled>
        {renderNavigationBtns({
          classPrev: "swiper-button-prev",
          classNext: "swiper-button-prev",
          nextSlide: handleNext,
          prevSlide: handlePrev
        })
        }

        {renderPagination({ index, total })}

        {isGradientBottom && <GradientBottom />}
      </SwiperWrapper>
    </>
  )
}

export default CarouselBase